module.exports = __webpack_public_path__ + "media/images/modal-close-w@3x-a16a1390d5f9bc5d3cee5a147b8e66d8.png";